module.exports = "//static.hsappstatic.net/settings-ui-app/static-1.14467/images/shopify_disabled.png"